import * as React from 'react'

import CircularProgress from '@material-ui/core/CircularProgress'
import styled           from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
`

const Content = styled.div`
  width: 100%;
  height: 100%;
`

const OverLay = styled.div`
  position: absolute;
  background: rgba(255,255,255, 0.5);
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

interface LoadingOverlayProps {
  children: any
  show: boolean
}

export default ({ children, show }: LoadingOverlayProps) => (
  <Wrapper>
    <Content>
      {children}
    </Content>
    {show && (
      <OverLay>
        <CircularProgress />
      </OverLay>
    )}
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/components/atoms/LoadingOverlay.tsx